import Auth from '../../../ui/modules/auth'
import PropTypes from 'prop-types'

import {
  Alert,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'

import { ReactComponent as EnvelopeSimple } from '../../../assets/icons/envelope-simple.svg'

import { makeFormPropTypes } from '../../../common/formikPropTypes'
import { requestPasswordResetPropTypes } from '../../../common/propTypes'
import useTranslations from '../../../i18n/useTranslations'
import { COGNITO_ERRORS_MAP } from '../../../auth/cognito/errors'

import styles from './styles'

const RequestPasswordReset = ({
  values,
  fieldErrors,
  formErrors,
  touched,
  onChange,
  onBlur,
  onSubmit,
  isSendingRequest,
}) => {
  const t = useTranslations()

  const infoAlert = {
    type: 'warning',
    text: t('request-password-reset:warning:check-spam'),
  }
  const getErrorAlert = error => ({
    type: 'error',
    text: t(COGNITO_ERRORS_MAP[error] ?? 'error:general'),
  })

  const alertContent =
    !formErrors || !formErrors.length ? infoAlert : getErrorAlert(formErrors[0])

  const isSubmitBtnDisabled =
    formErrors?.length !== 0 || Object.entries(fieldErrors)?.length !== 0

  return (
    <Auth title={t('login:title')} onSubmit={onSubmit}>
      <Grid item>
        <Typography variant="body1" sx={styles.explanation}>
          {t('request-password-reset:explanation')}
        </Typography>
        <TextField
          id="email"
          label={t('noun:email')}
          autoComplete="email"
          error={Boolean(touched.email && fieldErrors.email)}
          helperText={
            touched.email && fieldErrors.email ? t(fieldErrors.email.key) : ' '
          }
          value={values.email}
          onChange={onChange}
          onBlur={onBlur}
          className="input-full"
        />
        <Alert severity={alertContent.type} sx={styles.alert}>
          <Typography variant="body2">{alertContent.text}</Typography>
        </Alert>
        <LoadingButton
          type="submit"
          fullWidth
          startIcon={<EnvelopeSimple />}
          sx={styles.submitButton}
          loading={isSendingRequest}
          disabled={isSubmitBtnDisabled}
          loadingIndicator={
            <CircularProgress sx={styles.circularProgress} size={16} />
          }
        >
          {t('action:send-me-the-code')}
        </LoadingButton>
      </Grid>
    </Auth>
  )
}

RequestPasswordReset.propTypes = {
  ...makeFormPropTypes(requestPasswordResetPropTypes),
  isSendingRequest: PropTypes.bool,
}

export default RequestPasswordReset
